import {Client} from "~/lib/models/client";

export type AppSettingsObject = {
  clientUUID: string,
  hasClients: boolean,
}

export type PartnerClientDto = {
  uuid: string,
  createdat: Date,
  name: string,
  active: boolean,
  siret?: string,
};


export function clientToDTO(client:Client): PartnerClientDto {
  return {
    uuid: client.uuid,
    createdat: client.createdAt,
    name: client.name,
    active: client.active,
    siret: client.siret,
  };
}